import { LoadingContainer } from 'peach/components'
import { useParams, useHistory } from 'peach/router'

import { DynamicForm, Page, PageHeader } from 'core/components'
import { useLoanTapesGenerate } from 'core/types'

type GenerateBody = {
  loanTapeIds?: Array<string> | null
  reportDates?: Array<string> | null
  forceReplace?: boolean
  uploadFile?: boolean
}

const GenerateLoanTapes = () => {
  const history = useHistory()
  const { companyId } = useParams<{ companyId?: string }>()

  const { mutateAsync: generateTapes } = useLoanTapesGenerate({ companyId })

  const initial: GenerateBody = {
    loanTapeIds: [],
    reportDates: [],
    forceReplace: false,
    uploadFile: true,
  }

  return (
    <LoadingContainer isLoading={false}>
      <Page variant='full'>
        <PageHeader title='Generate Loan Tapes' />
        <DynamicForm
          data={initial}
          fieldEditMode='all'
          fieldOrder={[
            'loanTapeIds',
            'reportDates',
            'forceReplace',
            'uploadFile',
          ]}
          fieldOverrides={{
            loanTapeIds: 'JsonInput',
            reportDates: 'JsonInput',
          }}
          onSubmit={async (payload: any) => {
            const body = payload as GenerateBody
            // API expects undefined instead of null for optional arrays
            const normalized = {
              ...body,
              loanTapeIds: body.loanTapeIds ?? undefined,
              reportDates: body.reportDates ?? undefined,
            }
            await generateTapes(normalized)
            history.push(`/companies/${companyId}/loan-tapes`)
          }}
          submitText='Generate Loan Tapes'
          validationRules={{
            reportDates: [
              (v: unknown) =>
                (typeof v === 'string' && v.trim().length > 0) ||
                'reportDates is required',
            ],
          }}
        />
      </Page>
    </LoadingContainer>
  )
}

export default GenerateLoanTapes
